export enum EVisioType {
    Jitsi = "Jitsi"
}